export const namedFunction = (name, fn) => Object.defineProperty(fn, 'name', { value: name });
